import { useContext, useEffect, useState } from "react";
import useEvents from "../../api/hooks/useEvents";
import useOffer from "../../api/hooks/useOffers";
import { logMsgBgColors } from "../../consts/misc";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import { Offer } from "../../interfaces";
import { formatDateYYYMMGG } from "../../utils/reformatDate";
import CustomInput from "../inputs/CustomInput";

const EventModal = (props: any) => {
  const { model, setRefresh } = useContext(MainContext);
  const { isMobile } = useIsMobile();
  const {
    logMessage,
    form,
    onEdit,
    setOnEdit,
    eventSelected,
    setEventSelected,
    deleteModalToggler,
    setDeleteType,
    tempLoading,
    messageOnScreen,
  } = props;

  const offersHook = useOffer();
  const eventsHook = useEvents();

  const [offersFiltered, setOffersFiltered] = useState<Offer[]>([]);

  useEffect(() => {
    if (model) offersHook.CTAs.getOffersByAcceptedModelId(model?.id);
  }, [model]);

  useEffect(() => {
    /* console.log(
      offersHook.RESPONSES.getOffersByAcceptedModelIdResponse,
      offersHook.RESULTS.getOffersByAcceptedModelIdResult
    ); */
    if (offersHook.RESPONSES.getOffersByAcceptedModelIdResponse?.ok) {
      setOffersFiltered(
        offersHook.RESULTS.getOffersByAcceptedModelIdResult.offerts
      );
    } else if (
      offersHook.RESPONSES.getOffersByAcceptedModelIdResponse?.ok === false
    ) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write(
        "subject",
        `Error ${eventsHook.RESPONSES.createEventResponse?.status}: `
      );
      logMessage.write(
        "other_text",
        `${eventsHook.RESPONSES.createEventResponse?.statusText}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
      handleCloseModal();
    }
  }, [offersHook.RESPONSES.getOffersByAcceptedModelIdResponse]);

  const handleCloseModal = () => {
    props.toggler.toggle();
    setOnEdit(false);
    setEventSelected(null);
    form.reset();
  };

  const handleOnDeleteClick = () => {
    setDeleteType("event");
    deleteModalToggler.toggle();
  };

  const manageEvent = (data: any) => {
    const finalObj: any = {
      starting_date: new Date(
        `${data.starting_date} ${data.starting_time}`
      ).toUTCString(),
      ending_date: new Date(
        `${data.ending_date} ${data.ending_time}`
      ).toUTCString(),
      address: data.address,
      offert_id: data.related_offer_id,
    };

    if (
      new Date(finalObj.starting_date).getTime() <=
      new Date(finalObj.ending_date).getTime()
    ) {
      if (onEdit && eventSelected) {
        eventsHook.CTAs.updateEvents(eventSelected.id, finalObj);
      } else {
        const lastObj = { ...finalObj, model_id: model?.id };
        eventsHook.CTAs.createEvent(lastObj);
      }
    } else {
      messageOnScreen.toggle();
      logMessage.write("subject", `Starting date `);
      logMessage.write("other_text", `cannot be greater than Ending date`);
      logMessage.write("complement", "successfully!");
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  };

  useEffect(() => {
    /* console.log(
      eventsHook.RESPONSES.createEventResponse,
      eventsHook.RESULTS.createEventResult
    ); */
    if (eventsHook.RESPONSES.createEventResponse?.ok) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write("subject", "Event ");
      logMessage.write("other_text", "has been created ");
      logMessage.write("complement", "successfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      handleCloseModal();
    } else if (eventsHook.RESPONSES.createEventResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write(
        "subject",
        `Error ${eventsHook.RESPONSES.createEventResponse?.status}: `
      );
      logMessage.write(
        "other_text",
        `${eventsHook.RESPONSES.createEventResponse?.statusText}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
      handleCloseModal();
    }
  }, [eventsHook.RESPONSES.createEventResponse]);

  useEffect(() => {
    /* console.log(
      eventsHook.RESPONSES.updateEventsResponse,
      eventsHook.RESULTS.updateEventsResult
    ); */
    if (eventsHook.RESPONSES.updateEventsResponse?.ok) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write("subject", "Event ");
      logMessage.write("other_text", "has been updated ");
      logMessage.write("complement", "successfully!");
      logMessage.write("bgColor", logMsgBgColors.correct);
      setRefresh((prevState) => !prevState);
      handleCloseModal();
    } else if (eventsHook.RESPONSES.updateEventsResponse?.ok === false) {
      tempLoading.setIsToggled(false);
      messageOnScreen.toggle();
      logMessage.write(
        "subject",
        `Error ${eventsHook.RESPONSES.updateEventsResponse?.status}: `
      );
      logMessage.write(
        "other_text",
        `${eventsHook.RESPONSES.updateEventsResponse?.statusText}`
      );
      logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [eventsHook.RESPONSES.updateEventsResponse]);

  const renderOptionsOnCreate = offersFiltered.map(
    (item: Offer, key: number) => {
      return (
        <option key={key} value={item.id}>
          {item.offer_name}
        </option>
      );
    }
  );

  return (
    <div
      className="modal-wrapper"
      style={{
        height: `100vh`,
        zIndex: deleteModalToggler.isToggled ? "2" : "",
      }}
    >
      <div
        className="event-modal"
        style={{
          width: isMobile ? "calc(345px - (72px + 29px))" : "",
          height: isMobile ? "620px" : "",
          paddingBottom: isMobile ? "50px" : "",
        }}
      >
        <div className="modal-header">
          <div>
            <p className="modal-title">
              {onEdit ? `Edit ` : "Create new"} Event
            </p>
          </div>
          <div className="Oval" onClick={handleCloseModal}>
            <img src={`${toIcons}/close.svg`} />
          </div>
        </div>

        <form onSubmit={form.handleSubmit(manageEvent)}>
          <div
            className="customInputText-box"
            style={{ width: `100%`, marginTop: isMobile ? "25px" : "15px" }}
          >
            <p className="customInputText-title">Offer's name</p>
            <select
              id="event-offer-select"
              className={`customInputText-input`}
              style={{ width: " 100% ", appearance: "none" }}
              {...form.register("related_offer_id", {
                required: true,
              })}
              defaultValue={onEdit && eventSelected.related_offer_id}
            >
              {onEdit ? (
                <option value={eventSelected.related_offer_id}>
                  {eventSelected.related_offer_name}
                </option>
              ) : (
                <>
                  <option></option>
                  {renderOptionsOnCreate}
                </>
              )}
            </select>
            <label
              htmlFor="event-offer-select"
              style={{
                position: "absolute",
                transform: "TranslateX(-200%) TranslateY(55%)",
              }}
            >
              <img src={`${toIcons}/small-down.svg`} />
            </label>
          </div>
          <div
            className="customInputText-box"
            style={{ width: `100%`, marginTop: isMobile ? "25px" : "55px" }}
          >
            <div style={{ marginTop: isMobile ? "-10px" : "-40px" }}>
              <CustomInput
                title={"Address of appointment"}
                name={"address"}
                type={"text"}
                register={form.register}
                errors={form.formState.errors}
                locationIcon={true}
                width={isMobile ? "111%" : "104%"}
                defaultValue={onEdit ? eventSelected.address : ""}
                constraints={{
                  required: true,
                  validate: (value: string) => value.trim() !== "",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "unset" : "center",
                justifyContent: "space-between",
                marginTop: "25px",
                gap: isMobile ? "20px" : "",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "11px",
                }}
              >
                <CustomInput
                  title={"Starts"}
                  name={"starting_date"}
                  type={"Date"}
                  register={form.register}
                  errors={form.formState.errors}
                  width={"138px"}
                  noIcon={true}
                  defaultValue={
                    onEdit && formatDateYYYMMGG(eventSelected.starting_date)
                  }
                  constraints={{
                    required: true,
                  }}
                />
                <CustomInput
                  title={" "} // do not delete this (need to center the element)
                  name={"starting_time"}
                  type={"time"}
                  register={form.register}
                  errors={form.formState.errors}
                  width={"85px"}
                  noIcon={true}
                  defaultValue={
                    onEdit && eventSelected.starting_date.toLocaleTimeString()
                  }
                  constraints={{
                    required: true,
                  }}
                />
              </div>
              {!isMobile && <p className="mini-separator">-</p>}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "11px",
                }}
              >
                <CustomInput
                  title={"Ends"}
                  name={"ending_date"}
                  type={"Date"}
                  register={form.register}
                  errors={form.formState.errors}
                  width={"138px"}
                  noIcon={true}
                  defaultValue={
                    onEdit && formatDateYYYMMGG(eventSelected.ending_date)
                  }
                  constraints={{
                    required: true,
                  }}
                />
                <CustomInput
                  title={" "} // do not delete this (need to center the element)
                  name={"ending_time"}
                  type={"time"}
                  register={form.register}
                  errors={form.formState.errors}
                  width={"85px"}
                  noIcon={true}
                  defaultValue={
                    onEdit && eventSelected.ending_date.toLocaleTimeString()
                  }
                  constraints={{
                    required: true,
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              marginTop: isMobile ? "" : "25px",
              alignItems: "center",
            }}
          >
            {onEdit && (
              <div
                className="offer-ctas-delete-box offLightBlue"
                style={{
                  marginTop: isMobile ? "20px" : "",
                }}
                onClick={handleOnDeleteClick}
              >
                <img
                  className="offer-ctas-delete-icon"
                  src={`${toIcons}/delete.svg`}
                />
                <p className="offer-ctas-delete-text">Delete event</p>
              </div>
            )}
            <button
              className="button2 proposal-modal-button-addon"
              type="submit"
              style={{
                marginTop: isMobile ? "20px" : "",
                width: isMobile ? "100%" : "",
              }}
            >
              <p className="button2-text">Save</p>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default EventModal;
